import React from 'react';
import './HomeCtaBanners.css';
import { useNavigate } from 'react-router-dom';

const HomeCtaBanners = () => {
  const navigate = useNavigate();

  return (
    <div className="home-cta-section container py-4">
      <div className="row g-4">
        {/* Left Banner */}
        <div className="col-md-6">
          <div className="cta-banner cta-blue d-flex align-items-center justify-content-between p-4 rounded-4 shadow-sm h-100 position-relative overflow-hidden">
            <div className="cta-content z-1">
              <h4 className="fw-bold mb-4 text-dark-blue" style={{ fontSize: '1.5rem' }}>
                List your property <br /> & associated business
              </h4>
              <button 
                className="btn btn-dark rounded-pill px-4 py-2 d-flex align-items-center fw-bold"
                style={{ backgroundColor: '#1A1A1A', border: 'none' }}
                onClick={() => navigate('/list-your-property')}
              >
                List now <i className="bi bi-arrow-right ms-2"></i>
              </button>
            </div>
            <div className="cta-image-wrapper">
              <img 
                src="/home-banner/cta-banners/businessmen.png" 
                alt="List property" 
                className="img-fluid" 
              />
            </div>
          </div>
        </div>

        {/* Right Banner */}
        <div className="col-md-6">
          <div className="cta-banner cta-green d-flex align-items-center justify-content-between p-4 rounded-4 shadow-sm h-100 position-relative overflow-hidden">
            <div className="cta-content z-1">
              <h4 className="fw-bold mb-4 text-dark-blue" style={{ fontSize: '1.5rem' }}>
                For Purchase & <br /> Service related queries
              </h4>
              <button 
                className="btn btn-dark rounded-pill px-4 py-2 d-flex align-items-center fw-bold"
                style={{ backgroundColor: '#1A1A1A', border: 'none' }}
                onClick={() => navigate('/purchase-request')}
              >
                Reach out to us <i className="bi bi-arrow-right ms-2"></i>
              </button>
            </div>
            <div className="cta-image-wrapper">
              <img 
                src="/home-banner/cta-banners/businesswomen.png" 
                alt="Queries" 
                className="img-fluid" 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCtaBanners;
